import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

interface CountUpProps {
  end: number;
  duration?: number;
  className?: string;
  delay?: number;
}

export const CountUp: React.FC<CountUpProps> = ({ 
  end, 
  duration = 2000,
  className = '',
  delay = 0
}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const startTime = Date.now() + delay;
    const startValue = 0;

    const animate = () => {
      const currentTime = Date.now();
      const elapsed = currentTime - startTime;
      
      if (elapsed < 0) {
        requestAnimationFrame(animate);
        return;
      }

      const progress = Math.min(elapsed / duration, 1);
      setCount(Math.round(startValue + (end - startValue) * progress));
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [end, duration, delay]);

  return (
    <motion.span
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: delay / 1000 }}
      className={className}
    >
      {count}
    </motion.span>
  );
};